import { MASK_FORMAT } from 'config/ui';

function equalityValidator({ configs, fieldValues, fields, input, msgs }) {
  const field = fields[configs.clientId];
  const { format } = field;

  const unMask = (val) => {
    const maskToReplace = new RegExp(`[${Object.keys(MASK_FORMAT)}]`, 'g');
    const charsToReplace = `[${[...new Set(format.replace(maskToReplace, ''))].join('')}]`;

    return val.replace(new RegExp(charsToReplace, 'g'), '');
  };
  const unmaskedValue = format
    ? unMask(fieldValues[configs.clientId])
    : fieldValues[configs.clientId];
  const unmaskedInput = format ? unMask(input) : input;

  if (field && unmaskedValue !== unmaskedInput) {
    return (msgs && msgs.msg) || `Value must match ${field.label}`;
  }

  return null;
}

export default equalityValidator;
